<!-- add-product-modal.component.html -->
<div class="modal-header">
  <h4 class="modal-title">Dodaj Izdelek</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<div class="modal-body">
  <form>
    <div class="mb-3">
      <label for="productName" class="form-label">Ime izdelka</label>
      <input type="text" id="productName" class="form-control" [(ngModel)]="newProduct.name" name="name">
    </div>
    <div class="mb-3">
      <label for="productDescription" class="form-label">Opis</label>
      <textarea class="form-control" id="productDescription" [(ngModel)]="newProduct.description" name="description"></textarea>
    </div>
    <div class="mb-3">
      <label for="productType" class="form-label">Tip</label>
      <select class="form-control" id="productType" [(ngModel)]="newProduct.type" name="type">
        <option value="dairy">Mlečni izdelek</option>
        <option value="vegetable">Zelenjava</option>
        <option value="meat">Meso</option>
        <option value="other">Ostalo</option>
      </select>
    </div>
    <div class="mb-3">
      <label for="productImage" class="form-label">Slika izdelka</label>
      <div class="d-flex align-items-center">
        <fa-icon class="me-3" [icon]="faImage"></fa-icon>
        <input id="uploadImageInput" (change)="onImageUploadChanged($event)" type="file" class="form-control" accept=".png,.jpeg,.jpg">
      </div>
      <img *ngIf="previewImageSrc" class="mt-3 img-thumbnail" [src]="previewImageSrc" style="max-width: 100%;">
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cancel()">Prekliči</button>
  <button type="button" class="btn btn-primary" (click)="addNewProduct()">Shrani</button>
</div>
